import { buildService } from '../service';
import serviceMethods from '../service_methods';
import { useCallback } from 'react';
const api = buildService('/all/claim_groups/{id}/claim_project_reports', {
  only: ['all']
});
const useFetchAll = _ref => {
  let {
    claimGroupId,
    setLoading,
    onSuccess
  } = _ref;
  const [reports, setReports, fetchAllReports] = serviceMethods.useFetch({
    callback: useCallback(async () => await api.all(claimGroupId), [claimGroupId]),
    setLoading,
    onSuccess
  });
  return [reports, setReports, fetchAllReports];
};
export const claimProjectReportsAllService = {
  useFetchAll
};